import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `tabs` component.
 * Keep in sync with TabsProps and TabItem in src/ui/uiConfig/components/Tabs/Tabs.tsx
 */
export const tabsPropDocs: ComponentDocMap = {
  items: {
    description: 'Array of tab definitions. Each tab can show a different set of children based on its children_ids.',
    type: 'TabItem[]',
    example: '[{ title: "__Optimal", children_ids: [42] }, { title: "__Outcome", children_ids: [43] }]',
  },
  'items[].title': {
    description: 'Tab label. Prefix with __ for i18n translation.',
    type: 'string',
    example: '"__Daily view"',
  },
  'items[].children_ids': {
    description:
      "UiConfig IDs that are rendered when this tab is active. These must also appear in the parent config's children_ids.",
    type: 'number[]',
    example: '[42, 43]',
  },
  'items[].tooltip': {
    description: 'Tooltip shown when hovering over the tab.',
    type: 'string',
    example: '"__Shows optimal production plan"',
  },
  style: {
    description: 'Visual style of the tab strip. "tab" is a standard tab bar, "toggle" is a pill toggle.',
    type: '"tab" | "toggle"',
    example: '"toggle"',
  },
  sticky: {
    description: 'Pins the tab bar to the top of the viewport when scrolling.',
    type: 'boolean',
    example: 'true',
  },
  paddingTop: {
    description: 'Adds top padding before tab content.',
    type: 'boolean',
    example: 'true',
  },
}
